import { Hero } from "../sections/homepage/hero";
import { Services } from "../sections/homepage/services";
import { About } from "../sections/homepage/about";
import { Teams } from "../sections/homepage/teams";
import { Booking } from "../sections/homepage/booking";
import { CuratedExperiences } from "../sections/homepage/curatedExperiences";
import { Explore } from "../sections/homepage/explore";
import { TeamCityGuides } from "../sections/homepage/teamCityGuides";
import { Connections } from "../sections/homepage/connections";
import { AboutCreator } from "../sections/homepage/aboutCreator";
// import { AboutTeam } from "../sections/homepage/AboutTeam";
import { Faq } from "../sections/homepage/faq";
import { Testimonials } from "../sections/homepage/testimonials";
import { Footer } from "../sections/homepage/footer";
import { SEO } from "../components/seo";
import {
  StructuredData,
  organizationSchema,
  mobileAppSchema,
  serviceSchema,
} from "../components/structured-data";

function Homepage() {
  return (
    <>
      <SEO
        title="League Life - Curated Connections for Athletes & Their Families"
        description="League Life brings trusted resources and curated experiences to athletes and their families. From vetted local schools and healthcare to restaurants, wellness services, and social introductions."
        canonicalUrl="https://leaguelife.com/"
      />
      <StructuredData data={organizationSchema} />
      <StructuredData data={mobileAppSchema} />
      <StructuredData data={serviceSchema} />
      <Hero />
      <Services />
      <About />
      <Teams />
      <Testimonials />
      <Booking />
      <CuratedExperiences />
      <Explore />
      <TeamCityGuides />
      <Connections />
      <AboutCreator />
      {/* <AboutTeam /> */}
      <Faq />
      <Footer />
    </>
  );
}

export default Homepage;
